<script lang="ts" setup></script>

<template>
	<div class="bs-sticky-bottom-container">
		<slot />
	</div>
</template>
